import { UsersIcon, ChevronRightIcon } from '../components/ui/Icons'
import './SelectOrganization.css'

interface Organization {
  id: number
  public_token?: string
  name: string
  slug: string
  member_role: string
  member_count: number
  realm_status?: string
}

interface Props {
  organizations: Organization[]
  onSelect: (org: Organization) => void
  onLogout: () => void
}

export default function SelectOrganization({ organizations, onSelect, onLogout }: Props) {
  const getRoleLabel = (role: string) => {
    switch (role) {
      case 'owner': return 'Inhaber'
      case 'admin': return 'Administrator'
      case 'member': return 'Mitglied'
      default: return role
    }
  }

  const getRoleBadgeClass = (role: string) => {
    switch (role) {
      case 'owner': return 'role-owner'
      case 'admin': return 'role-admin'
      default: return 'role-member'
    }
  }

  if (organizations.length === 0) {
    return (
      <div className="select-org-container">
        <div className="select-org-card">
          <div className="card-header">
            <div className="logo">IT-SCE</div>
            <h1>Organization Portal</h1>
          </div>
          <div className="no-orgs">
            <div className="no-orgs-icon">
              <UsersIcon size={48} color="#ccc" />
            </div>
            <h2>Keine Organisationen</h2>
            <p>Sie sind noch keiner Organisation zugeordnet.</p>
            <p className="no-orgs-hint">
              Kontaktieren Sie Ihren Administrator oder erstellen Sie eine neue Organisation.
            </p>
          </div>
          <button className="btn-logout-full" onClick={() => onLogout()}>
            Abmelden
          </button>
        </div>
      </div>
    )
  }

  return (
    <div className="select-org-container">
      <div className="select-org-card">
        <div className="card-header">
          <div className="logo">IT-SCE</div>
          <h1>Organisation auswählen</h1>
          <p className="card-subtitle">
            Wählen Sie eine Organisation, um fortzufahren
          </p>
        </div>

        <div className="org-list">
          {organizations.map((org) => (
            <button
              key={org.id}
              className="org-item"
              onClick={() => onSelect(org)}
            >
              <div className="org-avatar">
                {org.name.charAt(0).toUpperCase()}
              </div>
              <div className="org-item-info">
                <span className="org-item-name">{org.name}</span>
                <span className="org-item-meta">
                  <span className="org-member-count">
                    <UsersIcon size={14} />
                    {org.member_count} Mitglieder
                  </span>
                  <span className={`org-role-badge ${getRoleBadgeClass(org.member_role)}`}>
                    {getRoleLabel(org.member_role)}
                  </span>
                </span>
              </div>
              <span className="org-item-arrow">
                <ChevronRightIcon size={20} />
              </span>
            </button>
          ))}
        </div>

        <div className="card-footer">
          <button className="btn-logout-link" onClick={() => onLogout()}>
            Mit anderem Konto anmelden
          </button>
        </div>
      </div>
    </div>
  )
}
